<template>
  <section
    class="cardSelectItem"
    :class="{ 'cardSelectItem--disabled': disabled }"
  >
    <section class="cardSelectItem-contain">
      <section class="cardSelectItem-title">
        <h3>{{ title }}</h3>
        <h5>{{ subtitle }}</h5>
      </section>
      <app-select
        v-model="model"
        :disabled="disabled"
        class="cardSelectItem-select"
        :items="items"
        :label="label"
        item-text="text"
        item-value="value"
        @change="$emit('change', $event)"
      />
    </section>
    <section class="cardSelectItem-divider" />
  </section>
</template>

<script>
export default {
  name: 'CardSelectItem',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Object],
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    // disabled: {
    //   handler(disabled) {
    //     if (!disabled) {
    //       this.$emit('change', this.model);
    //     }
    //   },
    // },
  },
  mounted() {
    this.$emit('initialevent');
  },
};
</script>

<style lang="scss" scoped>
.cardSelectItem {
  padding: 15px 40px 0 40px;
  background-color: #f4f4f4;
  &-divider {
    border-top: 1px solid #ccc;
    width: calc(100% + 80px);
    margin-left: -40px;
  }
  &--disabled {
    & .cardSelectItem {
      &-title {
        & h3 {
          color: #ccc;
        }
        & h5 {
          color: #ccc;
        }
      }
    }
  }
  &-contain {
    display: flex;
    margin-bottom: 15px;
  }
  &-title {
    width: 160px;
    margin-right: 40px;
    & h3 {
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
      margin-bottom: 0;
    }
    & h5 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }
  }
  &-select {
    width: 256px;
    height: 50px;
  }

  // mobile
  @media screen and (max-width: 767px) {
    padding: 12px 12px 0 12px;
    &-divider {
      width: calc(100% + 24px);
      margin-left: -12px;
    }
    &-contain {
      flex-direction: column;
    }
    &-title {
      width: 100%;
      margin-right: 0;
      display: flex;
      h3 {
        margin-right: 15px;
        font-size: 14px;
      }
      margin-bottom: 9px;
    }
    &-select {
      width: 100%;
      &::v-deep .v-input__icon.v-input__icon--append {
        width: 30px;
        .v-icon {
          font-size: 28px;
        }
      }
    }
  }
}
</style>
